import o from "react";
import { cls as r } from "../../../helpers/cls.js";
import { EyeOff as s, Eye as n } from "@olxbr/ds-icons";
const e = _ref => {
  let {
    type: t,
    alterType: a
  } = _ref;
  return o.createElement("button", {
    className: r("olx-text-input__button-password"),
    "data-ds-component": "DS-TextInput-Button-Password",
    onClick: () => a(),
    "aria-label": t === "password" ? "Mostrar senha" : "Ocultar senha"
  }, t === "password" ? o.createElement(s, {
    color: "var(--color-secondary-100)"
  }) : o.createElement(n, {
    color: "var(--color-secondary-100)"
  }));
};
e.displayName = "ButtonPassword";
export { e as ButtonPassword };